import { useState } from 'react';

const IG_RE = /^[a-z0-9._]{1,30}$/;
const IG_ERROR = '@ inválido (solo minúsculas, números, ".", "_")';
const BANNED = ['jugador', 'debook', '3333', 'thegame'];
const BANNED_ERROR =
  "@ no válido — sin 'the3333games', 'debook' ni 'jugador' en el nombre";

export type IgInputState = {
  value: string;
  error: string;
  onChange: (v: string) => void;
};

export type IgInputForm = IgInputState & {
  validate: () => string | null;
};

function normalize(raw: string): string {
  return raw.replace(/@/g, '').toLowerCase().trim();
}

function findBanned(norm: string): string | null {
  for (const word of BANNED) if (norm.includes(word)) return word;
  return null;
}

export function useIgInput(): IgInputForm {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');
  const onChange = (raw: string): void => {
    setValue(raw.replace(/@/g, ''));
    setError('');
  };
  const validate = (): string | null => {
    const norm = normalize(value);
    if (!IG_RE.test(norm)) {
      setError(IG_ERROR);
      return null;
    }
    if (findBanned(norm)) {
      setError(BANNED_ERROR);
      return null;
    }
    return norm;
  };
  return { value, error, onChange, validate };
}
